import type { ThemeConfig } from "antd";

// Funny color scheme

export const primaryColor = "#522ca9";
export const secondary = "";

export const AntTheme = (): ThemeConfig => {
    const themeValues: ThemeConfig = {
        token: {
            colorPrimary: primaryColor,
            colorTextPlaceholder: "#000"
        },
        cssVar: true,
        components: {
            Input: {
                controlHeightLG: 48,
            },
            Select: {
                controlHeightLG: 48
            }
        },
    };

    return themeValues;
};
